import React from "react";
import AppButton from "../../element/button/AppButton";
import {IContentBlock} from "../../../ts/data/subject/PostDataHelper";


const BlockIntroView = (block: IContentBlock) =>
{
    const more = !!block.hasMoreButton && !!block.moreButton && !!block.moreButtonCopy;
    const hasCtas = !!block.hasCtas && !!(block.ctas ?? []).length;
    const hasBtns = more || hasCtas || (!!block.internalLink || !!block.externalLink);
    return <>
        {(block.alignment === "text-center") ?  <>
            {!!block.title && <>
                <h2 className="block-title">{block.title}</h2>
            </>}
            {!!block.introduction && <>
                <p className="lead block-introduction">{ block.introduction }</p>
            </>}
            {(!!block.internalLink || !!block.externalLink) && <>
                <p>
                    <AppButton
                        href={block.externalLink ? block.externalLink:  block.internalLink}
                        title={"Read more about "+block.title}
                        className={"btn mt-3" + (block.externalLink? 'external' : 'internal')}
                    >
                        { block.buttonCopy ? block.buttonCopy : "Read More" }
                    </AppButton>
                    {hasCtas && <>

                    </>}
                    {more && <>

                        <AppButton href={block.moreButton} className="btn view-all mt-3">{block.moreButtonCopy}</AppButton>
                    </>}
                </p>
            </>}
        </> : <>
            <div className="row d-flex align-items-center">

                <div className={"col-12 col-md-" + (hasBtns ? 8 : 10) + " text-start"}>

                    {!!block.title && <>
                        <h2 className="block-title">{block.title}</h2>
                    </>}
                    {!!block.introduction && <>
                        <p className="lead block-introduction">{ block.introduction }</p>
                    </>}

                </div>
                {hasBtns && <>

                    <div className="col-12 col-md-4 text-start text-md-end">
                        {(!!block.internalLink || !!block.externalLink) && <>
                            <p>
                                <AppButton
                                    href={block.externalLink ? block.externalLink:  block.internalLink}
                                    title={"Read more about "+block.title}
                                    className={"btn reduced mt-3 " + (block.externalLink? 'external' : 'internal')}
                                >
                                    { block.buttonCopy ? block.buttonCopy : "Read More" }
                                </AppButton>
                                {hasCtas && <>

                                </>}
                                {more && <>

                                    <AppButton href={block.moreButton} className="btn reduced view-all mt-3 ms-2">{block.moreButtonCopy}</AppButton>
                                </>}
                            </p>
                        </>}
                    </div>
                </>}
            </div>
        </>
        }

    </>
}
export default BlockIntroView;